import {
  Cell,
  CellTemplate,
  Compatible,
  Uncertain,
  UncertainCompatible,
  getCellProperty,
} from "@silevis/reactgrid";
import * as React from "react";
import { HeaderCellCustomContainer } from "../../style";
import FilterIcon, { IFilterInfo } from "@lhd/components/FilterIcon";
import TextToolTip from "@lhd/components/TextToolTip";
import { DisplaySize } from "@lhd/constants";

export interface CellProps extends Cell {
  index: number;
  type: "headerIcon";
  text: string;
  className?: string;
  icon?: React.ReactNode;
  required?: boolean;
  isActive?: boolean;
  width?: number;
  filterInfo?: IFilterInfo;
  setFilterInfo?: React.Dispatch<React.SetStateAction<IFilterInfo>>;
  columnId: string;
  filter: any;
  additionalField?: string[];
  hiddenFilter?: boolean;
  displaySize?: DisplaySize;
}

export class HeaderIconCellTemplate implements CellTemplate<CellProps> {
  getCompatibleCell(
    uncertainCell: Uncertain<CellProps>,
  ): Compatible<CellProps> {
    const text = getCellProperty(uncertainCell, "text", "string");
    const isActive = getCellProperty(uncertainCell, "isActive", "boolean");
    const filterInfo = uncertainCell.filterInfo;
    const setFilterInfo = uncertainCell.setFilterInfo;
    const columnId = uncertainCell.columnId || "";
    const required = uncertainCell.required || false;
    const index = uncertainCell.index || 0;
    const value = parseFloat(text);
    const filter = uncertainCell.filter;
    const additionalField = uncertainCell?.additionalField || [];
    return {
      ...uncertainCell,
      additionalField,
      filter,
      index,
      required,
      text,
      value,
      filterInfo,
      setFilterInfo,
      columnId,
      isActive,
    };
  }

  update(
    cell: Compatible<CellProps>,
    cellToMerge: UncertainCompatible<CellProps>,
  ): Compatible<CellProps> {
    return this.getCompatibleCell({ ...cell, text: cellToMerge.text });
  }

  render(cell: Compatible<CellProps>): React.ReactNode {
    const value = cell.text;
    const className = cell.className;
    const displaySize = cell.displaySize;
    return (
      <HeaderCellCustomContainer
        className={`${cell.hiddenFilter ? "" : "has-filter"}`}
      >
        <div className="header-container">
          <div
            className={`header-text d-flex justify-center ${
              className ? className : ""
            }`}
          >
            <div
              className={`d-flex ${className ? className : ""}`}
              style={{
                maxWidth: "100%",
              }}
            >
              <TextToolTip>{value}</TextToolTip>
              <span className="required-star">{cell?.required && "*"}</span>
            </div>
            {cell?.icon && <div className="header-icon">{cell.icon}</div>}
          </div>
          {!cell.hiddenFilter && (
            <FilterIcon
              setFilterInfo={cell.setFilterInfo}
              filterInfo={cell.filterInfo}
              columnId={cell.columnId}
              isActive={cell.isActive}
              filter={cell.filter}
              className="header-filter-icon-custom"
              additionalField={cell?.additionalField}
              showFilterIcon={cell.columnId !== "index"}
              displaySize={displaySize}
            />
          )}
        </div>
      </HeaderCellCustomContainer>
    );
  }
}
